import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  BookOpen,
  ChevronUp,
  ClipboardList,
  LayoutDashboard,
  Plus,
  Settings,
  Users
} from "lucide-react";

export default function Sidebar() {
  const location = useLocation();
  const isProgrammesRoute =
    location.pathname.startsWith("/admin/programmes");
  const [isProgrammesExpanded, setIsProgrammesExpanded] =
    useState(isProgrammesRoute);

  useEffect(() => {
    if (isProgrammesRoute) {
      setIsProgrammesExpanded(true);
    }
  }, [isProgrammesRoute]);

  return (
    <aside className="sidebar">

      <div className="sidebar-logo">
        <span className="sidebar-logo-mark">A</span>
        <h2>AptiGuide</h2>
      </div>

      <nav className="sidebar-nav">

        <NavLink to="/admin">
          <button><LayoutDashboard size={18} />Dashboard</button>
        </NavLink>

        <div className="sidebar-programmes-row">
          <NavLink to="/admin/programmes" className="sidebar-programmes-link">
            <span><BookOpen size={18} />Programmes</span>
          </NavLink>
          <button
            type="button"
            className={`sidebar-submenu-toggle ${isProgrammesExpanded ? "is-expanded" : ""}`}
            aria-expanded={isProgrammesExpanded}
            aria-controls="sidebar-programmes-submenu"
            aria-label={`${isProgrammesExpanded ? "Collapse" : "Expand"} Programmes submenu`}
            onClick={() => setIsProgrammesExpanded((expanded) => !expanded)}
          >
            <ChevronUp size={15} aria-hidden="true" />
          </button>
        </div>

        <div
          id="sidebar-programmes-submenu"
          className={`sidebar-submenu ${isProgrammesExpanded ? "is-expanded" : ""}`}
        >
          <NavLink to="/admin/programmes" end>
            <span className="sidebar-submenu-dot" />All Programmes
          </NavLink>
          <NavLink to="/admin/programmes?add=true">
            <Plus size={14} />Add Programmes
          </NavLink>
        </div>

        <NavLink to="/admin/assessments">
          <button><ClipboardList size={18} />Assessments</button>
        </NavLink>

        <NavLink to="/admin/users">
          <button><Users size={18} />Users</button>
        </NavLink>

        <NavLink to="/admin/settings">
          <button><Settings size={18} />Settings</button>
        </NavLink>

      </nav>

    </aside>
  );
}
